<template>
    <header class="header">
      <div class="header__center">
        <div class="header__logo">
          <nuxt-link :to="{ name: 'index' }">
            <img class="" src="/frontend/img/logo-c.svg" alt="会社手続きナビゲーター モチカケ">
          </nuxt-link>
        </div>
      </div>
    </header>
  </template>
  
  <script>
    export default {
      name: 'f-header-lp-minimal'
    }
  </script>
  